<template>
  <div class="w-full flex items-center gap-[6px]">
    <!-- ปุ่มลบ -->
    <ButtonComponent
      icon="MinusIcon"
      :bClass="'btn_shadow--2 !w-[42px] !h-[42px] !min-w-[42px] !min-h-[42px]'"
      :disabled="disabled || localFieldValue <= minValue"
      @clicked="decrement"
    />
    <!-- input number -->
    <input
      type="number"
      v-model="localFieldValue"
      @input="updateFieldValue($event.target.value)"
      @keydown="allowOnlyNumbers"
      class="w-full h-[42px] px-[10px] rounded-[4px] border-[1px] border-solid PC_Body1-R text-center outline-none no-spinner"
      :class="
        disabled
          ? 'border-[#DFDCDD] text-[#DFDCDD] bg-[#F3F2F2]'
          : 'border-[#B7B2B5] text-[#1F1D1F] bg-[#fff]'
      "
      :readonly="disabled"
      :min="minValue"
      :max="maxValue"
    />
    <!-- ปุ่มบวก -->
    <ButtonComponent
      v-if="maxValue"
      :icon="'AddIcon'"
      :bClass="'btn_shadow--2 !w-[42px] !h-[42px] !min-w-[42px] !min-h-[42px]'"
      :disabled="disabled || localFieldValue >= maxValue"
      @clicked="increment"
    />
    <ButtonComponent
      v-else
      :icon="'AddIcon'"
      :bClass="'btn_shadow--2 !w-[42px] !h-[42px] !min-w-[42px] !min-h-[42px]'"
      :disabled="disabled"
      @clicked="increment"
    />
  </div>
</template>
<script setup>
import { ref, watch, onMounted } from "vue";

const props = defineProps({
  fieldValue: { type: [String, Number], default: "" },
  inputClass: { type: String },
  disabled: { type: Boolean, default: false },
  minValue: { type: [String, Number], default: 0 },
  maxValue: { type: [String, Number], default: "" },
});

const emit = defineEmits(["update:fieldValue"]);

const localFieldValue = ref("");
const inputWidth = ref(20);
const sizer = ref(null);

watch(
  () => props.fieldValue,
  (newVal) => {
    // console.log("newVal", props.fieldValue);
    localFieldValue.value = newVal;
  },
  { immediate: true }
);

onMounted(() => {
  localFieldValue.value = props.fieldValue;
});

// const updateFieldValue = (val) => {
//   const num = parseInt(val || "0", 10); // ensure number
//   localFieldValue.value = num;
//   emit("update:fieldValue", num);
// };
const updateFieldValue = (val) => {
  // if (localFieldValue.value !== val) {
    let num = parseFloat(val || "0");

    if (num < props.minValue) num = props.minValue;
    if (props.maxValue != "" && num > props.maxValue) num = props.maxValue;

    localFieldValue.value = num;
    emit("update:fieldValue", num);
  // }
};

const allowOnlyNumbers = (e) => {
  const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete"];

  if (allowedKeys.includes(e.key) || (e.key >= "0" && e.key <= "9")) {
    return;
  }

  e.preventDefault();
};

const decrement = () => {
  const num = parseInt(localFieldValue.value || "0", 10);
  const newVal = num - 1;
  localFieldValue.value = newVal;
  emit("update:fieldValue", newVal);
};

const increment = () => {
  const num = parseInt(localFieldValue.value || "0", 10);
  const newVal = num + 1;
  localFieldValue.value = newVal;
  emit("update:fieldValue", newVal);
};
</script>

<style lang="scss" scoped>
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.no-spinner[type="number"] {
  -moz-appearance: textfield;
}

@media screen and (max-width: 64rem) {
  .PC_Body1-R {
    font-size: 16px !important;
  }
}
</style>
